// set up the default state for the module
const initialState = {
  show: false,
  settings: {
    title: '',
    message: '',
  },
};

const actions = {
  openAlert: {
    root: true,
    handler(context, settings) {
      context.commit('openAlert', settings);
    },
  },
  closeAlert: {
    root: true,
    handler(context) {
      context.commit('closeAlert');
      context.commit('resetSettings');
    },
  },
};

const mutations = {
  openAlert: (state, settings) => {
    state.show = true;
    state.settings.title = settings.title;
    state.settings.message = settings.message;
  },
  closeAlert: (state) => {
    state.show = false;
  },
  resetSettings: (state) => {
    state.settings.title = '';
    state.settings.message = '';
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
